import { cn } from "@/lib/tailwind"

export function SectionTitle(props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>) {
  return <p {...props} className={cn("mb-4 border-b font-bold text-primary-500 text-xl uppercase", props.className)} />
}
